module.exports = __webpack_public_path__ + "static/media/buy_rating_4.2378895a.jpg";